import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8001/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('dock_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('dock_token');
      localStorage.removeItem('dock_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
